<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" >close</mat-icon>
</button>

<div mat-dialog-content>
  <img class="img-viewer" [src]="url" alt="test">
</div>
